/* eslint-disable react/prop-types */
import React from 'react';

export const Pin = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M11.02 20.282c.555 0 1.003-.401 1.157-.945a3.539 3.539 0 0 1 3.413-2.597h5.904v1.18c0 .65.531 1.181 1.18 1.181.65 0 1.182-.531 1.182-1.18V6.11c0-.649-.532-1.18-1.181-1.18-.65 0-1.18.531-1.18 1.18v1.182H15.59c-1.63 0-3-1.099-3.413-2.598-.154-.544-.602-.945-1.157-.945h-.154c-.65 0-1.18.531-1.18 1.18v5.882l-8.267.023c-.65 0-1.18.532-1.18 1.181 0 .65.53 1.18 1.18 1.18l8.266-.023v5.928c0 .65.532 1.181 1.181 1.181z" />
  </svg>
);

export const Forms = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={className}
  >
    <path
      d="M8 6H21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12H21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 18H21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 6H3.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12H3.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 18H3.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Helpdesk = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={className}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.09 8.99999C9.64 7.43999 11.35 6.61999 12.92 7.16999C14.12 7.58999 14.93 8.72999 14.92 9.99999C14.92 12 11.92 13 11.92 13"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17H12.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Recipients = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={className}
  >
    <path
      d="M16.091 18.9997V17.4442C16.091 15.7254 14.6264 14.3333 12.8182 14.3333H6.27277C4.46458 14.3333 3.00003 15.7254 3.00003 17.4442V18.9997"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.54572 11.2222C11.3532 11.2222 12.8185 9.82937 12.8185 8.11122C12.8185 6.39308 11.3532 5.00024 9.54572 5.00024C7.73824 5.00024 6.27298 6.39308 6.27298 8.11122C6.27298 9.82937 7.73824 11.2222 9.54572 11.2222Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 18.9992V17.4437C21 16.0282 19.9854 14.7916 18.5454 14.4338"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.273 5.10083C17.0239 5.52859 18.0794 7.22407 17.6294 8.88845C17.3348 9.99284 16.4266 10.8484 15.273 11.1284"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Projects = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={className}
  >
    <path
      d="M16 4H18C19.1 4 20 4.9 20 6V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V6C4 4.9 4.9 4 6 4H8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Settings = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    className={className}
  >
    <path d="M21.0909 4.51371H18.6636V3.47166C18.6636 2.65814 18.0091 2 17.2 2H13.3091C12.5 2 11.8455 2.65814 11.8455 3.47166V4.51371H2.90909C2.40909 4.51371 2 4.92505 2 5.42779C2 5.93053 2.40909 6.34186 2.90909 6.34186H11.8455V7.38391C11.8455 8.19744 12.5 8.85558 13.3091 8.85558H17.2C18.0091 8.85558 18.6636 8.19744 18.6636 7.38391V6.34186H21.0909C21.5909 6.34186 22 5.93053 22 5.42779C22 4.92505 21.5909 4.51371 21.0909 4.51371ZM16.8455 7.02742H13.6636V3.82815H16.8455V7.02742Z" />
    <path d="M2.90909 12.9141H5.33636V13.9562C5.33636 14.7697 5.99091 15.4278 6.8 15.4278H10.6909C11.5 15.4278 12.1545 14.7697 12.1545 13.9562V12.9141H21.0909C21.5909 12.9141 22 12.5028 22 12.0001C22 11.4973 21.5909 11.086 21.0909 11.086H12.1545V10.0439C12.1545 9.2304 11.5 8.57227 10.6909 8.57227H6.8C5.99091 8.57227 5.33636 9.2304 5.33636 10.0439V11.086H2.90909C2.40909 11.086 2 11.4973 2 12.0001C2 12.5028 2.40909 12.9141 2.90909 12.9141ZM7.15455 10.4004H10.3364V13.5997H7.15455V10.4004Z" />
    <path d="M21.0909 17.6581H18.6636V16.6161C18.6636 15.8025 18.0091 15.1444 17.2 15.1444H13.3091C12.5 15.1444 11.8455 15.8025 11.8455 16.6161V17.6581H2.90909C2.40909 17.6581 2 18.0695 2 18.5722C2 19.0749 2.40909 19.4863 2.90909 19.4863H11.8455V20.5283C11.8455 21.3419 12.5 22 13.3091 22H17.2C18.0091 22 18.6636 21.3419 18.6636 20.5283V19.4863H21.0909C21.5909 19.4863 22 19.0749 22 18.5722C22 18.0695 21.5909 17.6581 21.0909 17.6581ZM16.8455 20.1718H13.6636V16.9726H16.8455V20.1718Z" />
  </svg>
);

export const SignOut = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={className}
  >
    <path
      d="M9 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 17L21 12L16 7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12H9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowPath = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
    />
  </svg>
);

export const SearchPlaceholderLight = ({ className }) => (
  <svg
    viewBox="0 0 68 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_216_31668)">
      <g clipPath="url(#clip1_216_31668)">
        <path
          d="M29.6667 61.3333C44.3943 61.3333 56.3333 49.3943 56.3333 34.6667C56.3333 19.9391 44.3943 8 29.6667 8C14.9391 8 3 19.9391 3 34.6667C3 49.3943 14.9391 61.3333 29.6667 61.3333Z"
          stroke="url(#paint0_linear_216_31668)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63 68L48.5 53.5"
          stroke="#3491FF"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <circle cx="49" cy="19" r="19" fill="#3390FF" fillOpacity="0.2" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_216_31668"
        x1="29.6667"
        y1="8"
        x2="29.6667"
        y2="61.3333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F3689" />
        <stop offset="0.820042" stopColor="#3491FF" />
      </linearGradient>
      <clipPath id="clip0_216_31668">
        <rect width="68" height="71" fill="white" />
      </clipPath>
      <clipPath id="clip1_216_31668">
        <rect width="66" height="66" fill="white" transform="translate(0 5)" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchPlaceholderDark = ({ className }) => (
  <svg
    viewBox="0 0 68 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_216_31673)">
      <g clipPath="url(#clip1_216_31673)">
        <path
          d="M29.6667 61.3333C44.3943 61.3333 56.3333 49.3943 56.3333 34.6667C56.3333 19.9391 44.3943 8 29.6667 8C14.9391 8 3 19.9391 3 34.6667C3 49.3943 14.9391 61.3333 29.6667 61.3333Z"
          stroke="url(#paint0_linear_216_31673)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63 68L48.5 53.5"
          stroke="#77B5FF"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <circle cx="49" cy="19" r="19" fill="white" fillOpacity="0.2" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_216_31673"
        x1="29.6667"
        y1="8"
        x2="29.6667"
        y2="61.3333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0074FF" />
        <stop offset="0.820042" stopColor="#77B5FF" />
      </linearGradient>
      <clipPath id="clip0_216_31673">
        <rect width="68" height="71" fill="white" />
      </clipPath>
      <clipPath id="clip1_216_31673">
        <rect width="66" height="66" fill="white" transform="translate(0 5)" />
      </clipPath>
    </defs>
  </svg>
);

export const Warn = ({ className }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <path
        id="path245"
        fill="#3390ff"
        strokeWidth="0"
        d="M 32,4.810125e-4 C 20.766319,4.810125e-4 -4.821918,46.23744 0.79492186,56.3872 6.4117617,66.536959 57.588238,66.536958 63.205078,56.3872 68.821918,46.237441 43.233679,4.821125e-4 32,4.810125e-4 Z M 32,17.436028 c 2.662148,0 5.324984,0.952389 5.851563,2.855469 C 38.90472,24.097656 34.106315,41.436028 32,41.436028 c -2.106316,0 -6.904719,-17.338372 -5.851562,-21.144531 C 26.675016,18.388417 29.337852,17.436029 32,17.436028 Z m 0,28.361328 a 4,4 0 0 1 4,4 4,4 0 0 1 -4,4 4,4 0 0 1 -4,-4 4,4 0 0 1 4,-4 z"
      />
    </g>
  </svg>
);

export const Cactus = ({ className }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <path
        id="path245"
        fill="#3390ff"
        strokeWidth="0"
        d="m 30.391003,63.98364 c -2.791624,-0.233978 -4.259177,-0.45375 -6.214685,-0.930674 -4.914545,-1.198595 -9.328627,-3.42815 -13.055795,-6.594486 -0.395898,-0.336328 -0.719815,-0.635541 -0.719815,-0.664918 0,-0.02937 0.342426,-0.07658 0.760947,-0.104897 0.424446,-0.02872 1.48852,-0.216132 2.40624,-0.423804 3.145008,-0.711686 3.460638,-0.77649 4.442288,-0.912091 1.216852,-0.168093 3.881093,-0.188378 4.935875,-0.03758 1.924858,0.275184 2.89547,0.50755 6.293241,1.506616 2.731286,0.803095 4.336242,1.094205 6.45777,1.171321 2.212537,0.08043 3.576436,-0.09557 7.074755,-0.912927 3.142507,-0.73422 4.497124,-0.935073 6.307495,-0.935228 0.736035,-6.2e-5 0.814768,-0.01591 1.048873,-0.211123 0.213753,-0.17824 0.253107,-0.268235 0.253107,-0.578816 0,-0.307584 -0.04456,-0.411917 -0.27232,-0.637626 -0.369447,-0.366118 -0.764604,-0.413776 -2.483544,-0.299528 -1.696629,0.112763 -2.778537,0.292106 -5.306066,0.879557 -2.832345,0.658296 -3.5805,0.771875 -5.429463,0.824258 -2.539948,0.07196 -3.995386,-0.153496 -7.22587,-1.119324 -4.653553,-1.39129 -6.519772,-1.701961 -9.638371,-1.604506 -2.206373,0.06895 -3.815437,0.309064 -6.439446,0.960939 -1.601968,0.397972 -2.76317,0.563251 -3.9572097,0.563251 H 8.5446041 L 8.0901047,53.453296 C 7.5920802,52.939646 6.8578562,52.093547 6.5049503,51.62661 l -0.2253181,-0.298123 0.4358115,-0.09439 c 1.7746578,-0.38434 3.9870933,-0.411052 6.8524513,-0.08274 1.35093,0.154794 1.842101,0.173278 3.619642,0.136217 2.165362,-0.04514 2.609958,-0.09571 5.141061,-0.5848 2.495715,-0.482242 2.812246,-0.53479 3.949176,-0.655611 2.04637,-0.217468 3.700597,-0.115894 6.010619,0.369059 2.736688,0.574528 3.123039,0.650152 4.025661,0.787977 0.694705,0.106072 1.43779,0.144552 2.796996,0.14482 2.18004,4.07e-4 2.673037,-0.06586 5.769874,-0.775871 3.63529,-0.833458 4.835294,-0.945618 8.653338,-0.808798 l 1.137482,0.04076 0.199318,-0.228735 c 0.255973,-0.293753 0.27337,-0.838072 0.03633,-1.136705 -0.33423,-0.421077 -0.684367,-0.484409 -2.934129,-0.530725 -2.774351,-0.05712 -4.266117,0.118815 -7.515014,0.886303 -2.792184,0.659593 -4.570347,0.853303 -6.558751,0.714497 -1.151088,-0.08035 -1.919334,-0.212603 -4.629233,-0.796886 -2.400642,-0.517606 -3.25206,-0.602438 -5.55286,-0.553275 -2.186958,0.04674 -2.918215,0.137275 -5.982852,0.740795 -1.007756,0.198458 -2.183965,0.408585 -2.613798,0.466946 -1.244372,0.168961 -3.802942,0.126407 -5.635124,-0.09372 -1.148929,-0.138036 -2.009819,-0.188475 -3.249452,-0.19038 -1.7760935,-0.0027 -2.6996221,0.0827 -4.1895352,0.387545 L 5.1397267,49.656343 4.781032,49.119306 C 2.4397027,45.613881 0.75179126,40.665205 0.14873667,35.538178 -0.04829519,33.863066 -0.04985989,30.211875 0.14576698,28.609051 0.62955674,24.645212 1.6852516,21.055224 3.3674786,17.653323 5.0590205,14.232585 7.0490957,11.551691 9.9921147,8.7290629 13.814288,5.0632461 18.456917,2.4713468 23.597201,1.1335799 28.733576,-0.20317043 33.355268,-0.35214533 38.370669,0.65737437 43.372236,1.6641093 48.238126,3.9258704 52.19112,7.0813881 c 2.738386,2.1859468 5.47105,5.3592109 7.341053,8.5246909 2.282039,3.862959 3.691542,8.0547 4.358638,12.96221 0.166786,1.22696 0.135868,5.88813 -0.04758,7.174053 -0.629378,4.411644 -1.490531,7.316449 -3.178122,10.720318 -1.873839,3.779527 -4.446937,7.126479 -7.503195,9.759762 -4.924589,4.243043 -11.342272,6.925304 -18.287486,7.643226 -0.878766,0.09084 -3.868603,0.169521 -4.48342,0.117993 z m 0.722677,-3.056688 c 0.475487,-0.164262 0.698828,-0.768457 0.464757,-1.257283 -0.179236,-0.374305 -0.535486,-0.561714 -0.960414,-0.505233 -0.396745,0.05274 -0.612414,0.23728 -0.729361,0.6241 -0.118922,0.393327 0.06269,0.835539 0.435693,1.060903 0.311229,0.188042 0.434375,0.200135 0.789325,0.07752 z m 10.612003,-0.03961 c 0.219138,-0.152105 0.429157,-0.530651 0.429157,-0.773532 0,-0.322989 -0.251049,-0.713121 -0.549075,-0.853269 -0.978747,-0.460261 -1.761349,0.845895 -0.924792,1.54347 0.293642,0.244857 0.758577,0.281944 1.04471,0.08334 z M 22.757417,59.706886 c 0.397984,-0.109538 0.641096,-0.448476 0.641096,-0.893797 0,-0.462123 -0.412613,-0.896401 -0.851681,-0.896401 -0.61362,0 -0.959904,0.345394 -0.95631,0.953851 0.0021,0.353253 0.175825,0.612227 0.53289,0.794321 0.29304,0.149445 0.253288,0.14681 0.634005,0.04203 z M 18.157295,47.775889 c 0.11675,-0.10722 0.234948,-0.318165 0.262665,-0.468759 0.02772,-0.150594 0.03941,-3.09859 0.02597,-6.551103 -0.02409,-6.191559 -0.0268,-6.282307 -0.198084,-6.644151 -0.237298,-0.501292 -0.714509,-0.961043 -1.249447,-1.20374 -0.359463,-0.163085 -0.603176,-0.207351 -1.245796,-0.226279 -0.915775,-0.02697 -1.336377,-0.122141 -1.976971,-0.447345 -1.26619,-0.642787 -2.25773,-1.920841 -2.640314,-3.403253 -0.145072,-0.562116 -0.158758,-0.925642 -0.158758,-4.216935 0,-3.887439 0.01516,-4.047292 0.444965,-4.690914 0.416298,-0.623399 1.361745,-0.948007 2.1357,-0.733264 0.459341,0.127451 0.909011,0.492148 1.144195,0.927984 0.178078,0.330007 0.183751,0.423292 0.22384,3.681044 l 0.04113,3.342457 0.221043,0.336715 c 0.642568,0.978825 2.219223,0.950909 2.901926,-0.05138 l 0.249879,-0.366859 0.05277,-1.752751 c 0.02902,-0.964014 0.05679,-3.773766 0.06169,-6.243896 l 0.0089,-4.491142 0.250647,-0.497068 c 0.627343,-1.244113 2.115601,-1.791533 3.304051,-1.215317 0.535907,0.259831 1.075631,0.807334 1.326809,1.345929 0.177461,0.380525 0.177835,0.394943 0.218898,8.451986 0.04575,8.97692 -9.47e-4,8.296688 0.605726,8.824549 0.383596,0.333766 0.788685,0.452791 1.408017,0.413711 0.623466,-0.03934 1.04636,-0.313334 1.283988,-0.831893 0.14121,-0.308155 0.153916,-0.582361 0.155576,-3.357779 0.002,-3.401606 0.02473,-3.563122 0.577658,-4.11107 1.024918,-1.015683 2.685269,-0.616991 3.20152,0.768766 0.177405,0.476199 0.179694,0.540853 0.152962,4.320737 -0.02617,3.699286 -0.03364,3.856361 -0.20787,4.367203 -0.537078,1.574701 -1.852206,2.880259 -3.322543,3.298365 -0.255121,0.07255 -0.84183,0.14872 -1.303797,0.16927 -0.993088,0.04418 -1.395056,0.191196 -1.881835,0.688269 -0.659086,0.673022 -0.654072,0.632091 -0.669954,5.469433 -0.0078,2.350915 -0.01079,4.359756 -0.0067,4.464089 0.0041,0.104337 0.1155,0.296934 0.247759,0.427997 0.328516,0.325558 0.869683,0.338596 1.164259,0.02806 l 0.199434,-0.210245 0.02418,-2.316978 c 0.02213,-2.120265 0.03609,-2.316971 0.164529,-2.31688 0.420945,3.26e-4 2.500494,0.281687 3.389802,0.458687 1.874548,0.373092 3.035596,0.71351 6.869093,2.014011 2.848143,0.966224 4.21109,1.230028 6.334373,1.226052 2.090833,-0.0039 3.074307,-0.221249 7.300619,-1.613321 3.706067,-1.220713 6.099938,-1.760485 8.370783,-1.887456 1.096247,-0.06129 1.29153,-0.09931 1.341622,-0.261223 0.02394,-0.07736 0.196548,-0.580883 0.383585,-1.118937 0.693209,-1.994186 1.19812,-4.283547 1.447321,-6.56243 0.188972,-1.728098 0.128491,-5.34152 -0.115987,-6.929682 C 59.795229,22.349963 57.423058,17.136475 53.833388,13.038096 52.999515,12.086052 51.346066,10.459581 50.461736,9.7214549 47.988023,7.6567224 44.58805,5.7902933 41.249971,4.6646218 38.095931,3.6010123 35.136945,3.1094136 31.91294,3.113388 26.058787,3.1205621 20.264334,4.9660742 15.342345,8.3909389 7.9845349,13.510716 3.3828598,22.114512 3.1061538,31.269059 c -0.1055369,3.491586 0.391971,6.820997 1.5333489,10.261441 0.4518827,1.362106 0.715902,1.95656 0.8689826,1.95656 0.05927,0 0.5271817,-0.08931 1.0398139,-0.198454 1.1268722,-0.239934 2.9109476,-0.505591 4.1403768,-0.616519 0.992748,-0.08957 5.458976,-0.112619 5.874253,-0.03031 l 0.259694,0.05147 -0.0091,2.350944 c -0.0078,2.014149 0.0095,2.37712 0.120067,2.533651 0.299534,0.423793 0.876279,0.517136 1.223708,0.19805 z M 38.618606,38.04525 c -0.343318,-0.17064 -0.49188,-0.43509 -0.493519,-0.87849 -0.0038,-1.033351 1.447153,-1.293769 1.940527,-0.348284 0.169726,0.325256 0.09348,0.716255 -0.195615,1.003159 -0.395315,0.392316 -0.775345,0.460224 -1.251393,0.223615 z m -5.22692,-0.209715 c -0.234225,-0.232114 -0.285951,-0.344357 -0.285951,-0.620489 0,-0.748675 0.407175,-0.983623 1.704348,-0.983437 1.045548,1.63e-4 1.364846,0.11708 1.608191,0.58895 0.130979,0.253977 0.141621,0.348855 0.06496,0.579056 -0.05042,0.151421 -0.186029,0.363248 -0.301336,0.470726 -0.197138,0.183754 -0.278116,0.197002 -1.356953,0.221993 l -1.147304,0.02658 z m 11.338403,0.111537 c -0.180468,-0.109045 -0.295076,-0.265342 -0.365586,-0.498559 -0.09091,-0.300698 -0.08434,-0.373708 0.05722,-0.635704 0.327146,-0.605488 0.05827,-0.581053 6.395552,-0.581195 6.028644,-1.63e-4 5.888368,-0.0089 6.251734,0.389032 0.217048,0.237675 0.264855,0.67913 0.10643,0.982739 -0.272528,0.522262 -0.02955,0.50317 -6.399291,0.502834 -5.587081,-3.26e-4 -5.792087,-0.0057 -6.046052,-0.159147 z m -9.670104,-5.201097 c -0.244941,-0.150508 -0.473488,-0.551724 -0.473488,-0.831217 0,-0.24937 0.207064,-0.613395 0.461906,-0.812047 0.263921,-0.20573 0.831986,-0.22804 1.186079,-0.04658 0.643558,0.329798 0.643558,1.379432 0,1.70923 -0.318451,0.163193 -0.892775,0.153711 -1.174497,-0.0194 z m 5.936578,-0.04181 c -0.180558,-0.120198 -0.324233,-0.309271 -0.401043,-0.527754 -0.107352,-0.305353 -0.105562,-0.369793 0.01731,-0.625158 0.07535,-0.15659 0.238621,-0.350706 0.36282,-0.431367 0.21269,-0.13813 0.670797,-0.147924 7.880085,-0.168466 7.327626,-0.02088 7.666381,-0.01534 7.938042,0.129759 0.156075,0.08336 0.355469,0.288474 0.443097,0.455808 0.13723,0.262054 0.146075,0.348061 0.06379,0.620241 -0.05894,0.194941 -0.19717,0.387837 -0.360831,0.503521 l -0.265296,0.187522 -7.698312,0.0216 -7.698309,0.0216 z m 8.732804,-4.871306 C 47.834546,27.436385 46.449571,26.373516 45.638748,24.693595 44.55034,22.43856 45.2439,19.543787 47.236294,18.025776 c 1.744324,-1.329008 3.981114,-1.560324 5.942001,-0.614491 0.566166,0.273089 0.832752,0.470869 1.4007,1.039172 1.171459,1.172192 1.670742,2.341559 1.674595,3.922062 0.0029,1.181939 -0.237179,1.988513 -0.89776,3.016363 -0.985046,1.53271 -2.572526,2.423202 -4.439812,2.490495 -0.452455,0.0163 -0.986448,-0.0046 -1.186651,-0.04651 z M 7.7353351,47.041476 c 0.2279045,-0.225851 0.2796996,-0.339607 0.2796996,-0.614293 0,-0.6609 -0.5253825,-1.069172 -1.1584644,-0.900237 -0.759572,0.202688 -0.87529,1.288781 -0.1773006,1.664093 0.3922336,0.210906 0.7423543,0.161321 1.0560654,-0.149563 z m 5.0747119,0.02566 c 0.452934,-0.204512 0.614774,-0.94838 0.301261,-1.384701 -0.548301,-0.763078 -1.743213,-0.262103 -1.616036,0.677532 0.08581,0.633971 0.720652,0.97543 1.314775,0.707169 z M 29.057875,46.85631 c 0.360515,-0.223164 0.450149,-0.793989 0.190846,-1.215385 -0.476186,-0.773854 -1.654714,-0.424224 -1.654714,0.490898 0,0.758926 0.782562,1.146226 1.463868,0.724487 z"
      />
    </g>
  </svg>
);

export const InvalidLight = ({ className }) => (
  <svg
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="62" y="44" width="6" height="20" rx="1.33333" fill="#0F3689" />
    <rect
      x="62"
      y="68.3335"
      width="6"
      height="5.33333"
      rx="1.33333"
      fill="#0F3689"
    />
    <circle
      cx="65"
      cy="59"
      r="29"
      stroke="url(#paint0_linear_479_11840)"
      strokeWidth="6"
    />
    <circle cx="48.5" cy="83.5" r="19" fill="#3390FF" fillOpacity="0.2" />
    <defs>
      <linearGradient
        id="paint0_linear_479_11840"
        x1="65"
        y1="27"
        x2="65"
        y2="91"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F3689" />
        <stop offset="1" stopColor="#3390FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const InvalidDark = ({ className }) => (
  <svg
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="62" y="44" width="6" height="20" rx="1.33333" fill="#0074FF" />
    <rect
      x="62"
      y="68.3335"
      width="6"
      height="5.33333"
      rx="1.33333"
      fill="#0074FF"
    />
    <circle
      cx="65"
      cy="59"
      r="29"
      stroke="url(#paint0_linear_479_11833)"
      strokeWidth="6"
    />
    <circle cx="48.5" cy="83.5" r="19" fill="white" fillOpacity="0.2" />
    <defs>
      <linearGradient
        id="paint0_linear_479_11833"
        x1="65"
        y1="27"
        x2="65"
        y2="91"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0074FF" />
        <stop offset="1" stopColor="#77B5FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoMatchLight = ({ className }) => (
  <svg
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_479_11859)">
      <path
        d="M18.5 24H82.5C83.6046 24 84.5 24.8954 84.5 26V79C84.5 80.1046 83.6046 81 82.5 81H18.5C17.3954 81 16.5 80.1046 16.5 79V26C16.5 24.8954 17.3954 24 18.5 24Z"
        stroke="#3491FF"
        strokeWidth="4"
      />
      <path
        d="M14.5 26C14.5 23.7909 16.2909 22 18.5 22H82.5C84.7091 22 86.5 23.7909 86.5 26V42H14.5V26Z"
        fill="#3491FF"
      />
      <circle cx="27.5" cy="53" r="3" fill="#3491FF" />
      <circle cx="27.5" cy="66" r="3" fill="#3491FF" />
      <path
        d="M83 95.5C94.3218 95.5 103.5 86.3218 103.5 75C103.5 63.6782 94.3218 54.5 83 54.5C71.6782 54.5 62.5 63.6782 62.5 75C62.5 86.3218 71.6782 95.5 83 95.5Z"
        stroke="url(#paint0_linear_479_11859)"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.5 103.5L97.5 89.5"
        stroke="#3491FF"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="62.5" cy="79.5" r="16" fill="#3390FF" fillOpacity="0.2" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_479_11859"
        x1="70.5"
        y1="60.5"
        x2="107"
        y2="97.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.197917" stopColor="#0F3689" />
        <stop offset="0.713542" stopColor="#3491FF" />
      </linearGradient>
      <clipPath id="clip0_479_11859">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NoMatchDark = ({ className }) => (
  <svg
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_479_11821)">
      <path
        d="M18.5 24H82.5C83.6046 24 84.5 24.8954 84.5 26V79C84.5 80.1046 83.6046 81 82.5 81H18.5C17.3954 81 16.5 80.1046 16.5 79V26C16.5 24.8954 17.3954 24 18.5 24Z"
        stroke="#77B5FF"
        strokeWidth="4"
      />
      <path
        d="M14.5 26C14.5 23.7909 16.2909 22 18.5 22H82.5C84.7091 22 86.5 23.7909 86.5 26V42H14.5V26Z"
        fill="#77B5FF"
      />
      <circle cx="27.5" cy="53" r="3" fill="#77B5FF" />
      <circle cx="27.5" cy="66" r="3" fill="#77B5FF" />
      <path
        d="M83 95.5C94.3218 95.5 103.5 86.3218 103.5 75C103.5 63.6782 94.3218 54.5 83 54.5C71.6782 54.5 62.5 63.6782 62.5 75C62.5 86.3218 71.6782 95.5 83 95.5Z"
        stroke="url(#paint0_linear_479_11821)"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.5 103.5L97.5 89.5"
        stroke="#77B6FF"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="62.5" cy="79.5" r="16" fill="white" fillOpacity="0.2" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_479_11821"
        x1="70.5"
        y1="60.5"
        x2="107"
        y2="97.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.197917" stopColor="#0074FF" />
        <stop offset="0.713542" stopColor="#77B5FF" />
      </linearGradient>
      <clipPath id="clip0_479_11821">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
